import React from 'react';

interface PicnicTableIconProps {
  className?: string;
}

const PicnicTableIcon: React.FC<PicnicTableIconProps> = ({ className = "w-6 h-6" }) => {
  return (
    <svg 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      className={className}
    >
      {/* Table top */}
      <line x1="2" y1="10" x2="22" y2="10" />
      {/* Table support */}
      <line x1="6" y1="10" x2="6" y2="14" />
      <line x1="18" y1="10" x2="18" y2="14" />
      {/* Bench seat left */}
      <line x1="1" y1="14" x2="8" y2="14" />
      {/* Bench seat right */}
      <line x1="16" y1="14" x2="23" y2="14" />
      {/* Legs */}
      <line x1="4" y1="14" x2="3" y2="20" />
      <line x1="20" y1="14" x2="21" y2="20" />
      <line x1="9" y1="10" x2="7" y2="20" />
      <line x1="15" y1="10" x2="17" y2="20" />
    </svg>
  );
};

export default PicnicTableIcon;
